import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  subtitle: {
    marginTop: 10,
    marginBottom: 20,
  },
}));

const Subtitle = ({ ...props }) => {
  const classes = useStyles();
  const { subtitle } = props;
  return (
    <Typography variant="h5" className={classes.subtitle}>
      {subtitle}
    </Typography>
  );
};

Subtitle.propTypes = {
  subtitle: PropTypes.string,
};

export default Subtitle;
